import Vue from 'vue'
import shareBox from './shareBox'
import { is_app } from '@lyh/jsbridge'

const shareBoxConstructor = Vue.extend(shareBox)
let instance

const SharePicker = (share) => {
  /* eslint-disable */
  // let share = JSON.parse(sessionStorage.getItem('share'))
  let s = ''
  /* eslint-enable */
  // let s = ''
  // function isApp() {
  //   var ua = navigator.userAgent.toLowerCase()
  //   //console.log(ua);
  //   if (ua.match(/LYHApp/i) == 'lyhapp' && self == top) {
  //     s = 'app'
  //     return true
  //   } else {
  //     s = 'wx'
  //     //s = 'app';
  //     return false
  //   }
  // }
  if (is_app()) {
    console.log('调用了nativefun')
    window.nativefun(
      'showShare',
      {
        'param': {
          title: share.title,
          // text: share.sharedesc,
          image: share.imgUrl,
          url: share.link
        }
      },
      () => {
        // ...
      }
    )
  } else {
    // console.log(111)
    instance = new shareBoxConstructor({
      el: document.createElement('div')
    })
    instance.isShow = true
  }

  document.getElementById('app').appendChild(instance.$el)
}

export default SharePicker
